import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=b3a5e686&scoped=true&"
import script from "./tree.vue?vue&type=script&lang=js&"
export * from "./tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a5e686",
  null
  
)

export default component.exports